module.exports = __webpack_public_path__ + "static/img/grow.86ed8a29.png";